export default __webpack_public_path__ + "static/media/necesidad.d1fd55b7.png";